import { Box, Chip, useTheme } from "@mui/material";
import React from "react";


export type TabLabelProps = {
    label: string;
    count?: number;
    disabled?: boolean;
};

export default function TabLabel({ label, count, disabled }: TabLabelProps) {

    const theme = useTheme();
    

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        }}>
            {label}
            {(count !== undefined) && <Chip color="secondary" disabled={disabled} size="small" label={count} sx={{marginLeft: theme.spacing(1)}} />}
        </Box>
    );
}
